import React from "react";
/**
 * Context to determine if the current device is a mobile device
 */
export const IsMobileContext = React.createContext(window.innerHeight > window.innerWidth && window.innerWidth < 1000);
export const useIsMobile = () => React.useContext(IsMobileContext);
